// Default React Library import
import React from "react";
import ReactDOM from "react-dom";

// Multi lingual support library import
import './i18nextConf';

// Base styles import
import './Assets/CSS/Styles.scss';

// Entry point component import
import App from "./App";
import FilterProvider from "./Hooks/FilterProvider";

const LoadReactApp = () =>{
  const rootElement = document.getElementById("root");
  ReactDOM.render(
    <React.Fragment>
      <FilterProvider>
      <App />
      </FilterProvider>
    </React.Fragment>,
    rootElement
  );
}

window.addEventListener('DOMContentLoaded', LoadReactApp)